import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import LeftMainDrawerDesktop from './LeftMainDrawerDesktop.component';
import LeftMainDrawerMobile from './LeftMainDrawerMobile.component';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Box from '@mui/material/Box';

import LayersRoundedIcon from '@mui/icons-material/LayersRounded';
import PlaceIcon from '@mui/icons-material/Place';
import ForestRoundedIcon from '@mui/icons-material/ForestRounded';
import TimelineIcon from '@mui/icons-material/Timeline';
import InfoIcon from '@mui/icons-material/Info';
import DonutLargeIcon from '@mui/icons-material/DonutLarge';
import BarChartIcon from '@mui/icons-material/BarChart';
import logoRss from '../../Images/logoRssLight.png';
import logoNWALight from '../../Images/logoNWALight.png';
import { Divider, Grid, styled } from '@mui/material';
import ShareIcon from '@mui/icons-material/Share';
import useAnalyticsEventTracker from '../../Services/useAnalyticsEventTracker.service';
import FireIcon from '@mui/icons-material/Whatshot';
// import FireIcon from '@mui/icons-material/LocalFireDepartment';
import { keyframes } from '@mui/system';
import TrackChangesIcon from '@mui/icons-material/TrackChanges';

import { useEffect, useState } from 'react';
import ShowExample from '../../Language/ShowExample';
import useTranslation from '../../Language/useTranslation';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';



const blink = keyframes`
  from { opacity: 0.3; }
  to { opacity: 1; }
`;


export default function LeftMainDrawer(props: any) {
    const gaEventTracker = useAnalyticsEventTracker('Subdrawer');
    const theme = useTheme();

    const mobile = useMediaQuery(theme.breakpoints.down('sm'));

    const t = useTranslation();



    function handleClick(subdrawerType: any) {
        switch (subdrawerType) {
            case "WALDZUSTAND":
                props.setActiveLayer(t.layersWaldzustand[0].label)
                break;
            case "SCHADEN":
                props.setActiveLayer(t.layersSchaden[0].label)
                break;
            case "BAUMARTEN":
                props.setActiveLayer(t.layersBaumarten[0].label)
                break;
            case "FIRE":
                props.setActiveLayer(t.layersFeuer[0].label)
                break;
        }
        props.setLeftSubDrawerOpen(true)
        props.setLeftSubDrawerType(subdrawerType)

        gaEventTracker(subdrawerType)

    }

    const ListItemStyled = (props: any) => (
        <ListItem button onClick={props.handleClick}
            sx={{
                '&:hover': {
                    cursor: 'pointer',
                    color: '#65C18C',
                    '& .listIcon': {
                        color: '#65C18C',
                    }
                }
            }}>
            {props.children}
        </ListItem>
    );

    // create list of items to use to create the List

    const topItems = [
        {
            label: t.layerCategories.baumarten.name,
            icon: <DonutLargeIcon />,
            id: "BAUMARTEN"
        },
        {
            label: t.layerCategories.waldzustandMain.name,
            icon: <TimelineIcon />,
            id: "WALDZUSTAND"
        },
        {
            label: t.layerCategories.schaden.name,
            icon: <BarChartIcon />,
            id: "SCHADEN"
        },

        {
            label: t.layerCategories.feuer.name,
            icon: <FireIcon
            // sx={{ animation: `${blink} 1.5s linear infinite`, color: "red" }} 
            />,
            id: "FIRE"
        },
        {
            label: t.layerCategories.bundesland.name,
            icon: <PlaceIcon />,
            id: "BUNDESLAENDER"
        },



    ]
    const bottomItems = [
        {
            label: t.layerCategories.informationen.name,
            icon: <InfoIcon />,
            id: "INFORMATIONEN"
        },
        {
            label: t.layerCategories.teilen.name,
            icon: <ShareIcon />,
            id: "TEILEN"
        },
    ]

    //create list with topItems on the top and bottomItems on the bottom the bottom of parent container

    const content = (

        <>
            <List

                sx={{
                    width: "100%",
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                    // alignItems: "space-between",
                    // backgroundColor: "red"
                }}
            >

                <Box
                    sx={{
                        width: "100%",
                        height: "100%",
                        display: "flex",
                        flexDirection: "column",
                        // justifyContent: "space-between",
                        alignItems: "center",
                        // backgroundColor: "red"
                    }}
                >
                    {topItems.map((item, index) => (
                        <ListItemStyled

                            key={index}
                            handleClick={() => handleClick(item.id)}
                        >
                            <ListItemIcon className="listIcon">
                                {item.icon}
                            </ListItemIcon>
                            <ListItemText primary={item.label} />
                        </ListItemStyled>
                    ))}
                </Box>

                <Divider />
                <Box
                    sx={{
                        width: "100%",
                        height: mobile ? "50%" : "500px",
                        display: "flex",
                        flexDirection: "column",
                        // justifyContent: "space-between",
                        alignItems: "center",
                        // marginBottom: "520 px",
                        // bottom: "200px",
                        // backgroundColor: "red"
                    }}
                >

                    {bottomItems.map((item, index) => (
                        <ListItemStyled

                            key={index}
                            handleClick={() => handleClick(item.id)}
                        >
                            <ListItemIcon className="listIcon">
                                {item.icon}
                            </ListItemIcon>
                            <ListItemText primary={item.label} />
                        </ListItemStyled>
                    ))}
                </Box>
            </List>

            <LogosComponent mobile={props.mobile} />
        </>

    )




    return (
        <>
            {props.mobile ?
                <LeftMainDrawerMobile
                    {...props}
                >
                    {content}
                </LeftMainDrawerMobile>
                :
                <LeftMainDrawerDesktop>
                    {content}
                </LeftMainDrawerDesktop>
            }
        </>);
}

function LogosComponent(props: any) {
    function openWebsite(url: string) {
        window.open(url, '_blank', 'noopener,noreferrer');

    }
    return (
        <ListItem sx={{
            position: "fixed",
            bottom: 0,
            textAlign: "center",
            paddingBottom: 5,
            // paddingLeft: 4

        }}>
            <Grid container alignItems="space-between" className="logos">
                <Box
                    component="img"
                    sx={{
                        // width: "80px",
                        mr: 3,
                        ...(props.mobile ? {

                            width: "18%"
                        } :
                            {
                                width: "80px",
                            }
                        ),
                    }}
                    onClick={() => openWebsite("https://www.remote-sensing-solutions.com")}

                    src={logoRss}
                />
                <Box
                    component="img"
                    sx={{
                        ...(props.mobile ? {
                            width: "45%"
                        } :
                            {
                                width: "210px",
                            }
                        ),
                    }}
                    src={logoNWALight}
                    onClick={() => openWebsite("https://naturwald-akademie.org/")}
                />
            </Grid>
        </ListItem>
    )

}